// Canonical course level option set. Mirrors the backend CourseLevel enum and
// the `levels` facet returned by the catalog metadata endpoint.
export const COURSE_LEVELS = [
  "Foundational",
  "Intermediate",
  "Advanced",
  "Expert",
] as const;

export type CourseLevel = (typeof COURSE_LEVELS)[number];

// A 4-tier semantic color scale for the Level badge. Cool/calm for the lower
// tiers escalating to warm for the higher tiers, with dark-mode variants per
// the design system. Falls back to neutral grey for any non-canonical value.
const LEVEL_BADGE_CLASSES: Record<string, string> = {
  Foundational:
    "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/40 dark:text-emerald-200 dark:border-emerald-800",
  Intermediate:
    "bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-900/40 dark:text-sky-200 dark:border-sky-800",
  Advanced:
    "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/40 dark:text-amber-200 dark:border-amber-800",
  Expert:
    "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-900/40 dark:text-rose-200 dark:border-rose-800",
};

const LEVEL_FALLBACK_CLASS =
  "bg-gray-100 text-gray-600 border-gray-200 dark:bg-slate-700 dark:text-gray-300 dark:border-slate-600";

// Returns the Tailwind class string for a Level badge, keyed off the level
// label. Unknown / null levels get the neutral fallback.
export function levelBadgeClasses(level: string | null | undefined): string {
  if (!level) {
    return LEVEL_FALLBACK_CLASS;
  }
  return LEVEL_BADGE_CLASSES[level] ?? LEVEL_FALLBACK_CLASS;
}
